module.exports = __webpack_public_path__ + "static/media/cancelar-compra.50f0fc95.svg";